<template>
  <div>
    <div id="contact">
      <div class="container">
        <div class="twelve columns">
          <h2>Contact</h2>
        </div>
        <div class="four columns text-right"><a class="font-bold font-color-blue" href="static/images/회사소개서_renasoftware.compressed.pdf" download>Brochure Download<span class="more-arrow-blue"></span></a></div>
      </div>
      <div class="container">
        <div class="eight columns" v-scroll-reveal="{ origin : 'left', duration : '1000', distance : '100px' }">
          <div class="contact-wrap">
            <p><i class="icon-contact1">&#xf095;</i><span>call :</span> 070 4366 0983</p>
            <p><i class="icon-contact1">&#xf02f;</i><span>FAX :</span> 0505 273 1196</p>
          </div>

        </div>
        <div class="eight columns" v-scroll-reveal="{ origin : 'right', duration : '1000', distance : '100px' }">
          <div class="contact-wrap">
            <p><i class="icon-contact1">&#xf041;</i><span>Visit Us:</span></p>
            <p>경기도 성남시 분당구 느티로 16 젤존타워1차 811호</p>
          </div>
        </div>
        <div class="sixteen columns" v-scroll-reveal="{ origin : 'bottom', duration : '1000', distance : '200px' }">
          <a class="button-map close-map"><span>Locate Us on Map</span></a>
        </div>
      </div>
      <div id="google_map"></div>
    </div>

    <div id="footer">
      <a class="scroll" href="#home"><div class="back-top">&#xf102;</div></a>
      <div class="container">
        <div class="footer-menu">
          <ul>
            <li><a v-on:click="menuClick('service')">회사소개</a></li>
            <li class="divide">|</li>
            <li><a v-on:click="menuClick('portfolio')">개발서비스</a></li>
            <li class="divide">|</li>
            <li><a v-on:click="menuClick('blog')">블로그</a></li>
            <li class="divide">|</li>
            <li><a v-on:click="menuClick('contact')">문의하기</a></li>
          </ul>
        </div>
        <div class="sixteen columns">
          <p>상호명 : 레나소프트웨어, 대표자명 : 권병천, 사업자등록번호 : 312-86-35503</p>
          <p><small>COPYRIGHT 2018 ⓒ RENASOFTWA, INC. ALL RIGHTS RESERVED</small></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BottomFooter',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    methods: {
      menuClick(title) {
        console.log('## click menu x: ' + title)
        //this.menuVisible = false
        this.$emit('clicked',title)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/BottomFooter.vue